var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconJs48Filled = function SvgIconJs48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4 9.3H14.6a5.31 5.31 0 0 0-5.3 5.3v18.8c0 2.92 2.38 5.3 5.3 5.3h18.8c2.92 0 5.3-2.38 5.3-5.3V14.6c0-2.92-2.38-5.3-5.3-5.3Zm-8.79 21.04c0 2.2-1.79 3.98-3.98 3.98a3.99 3.99 0 0 1-3.98-3.98v-.29h3.4v.29a.58.58 0 0 0 1.16 0v-7.72h3.4v7.72ZM30 34.35c-2.7 0-4.37-1.56-4.37-4.08v-.21h3.44v.21c0 .63.47.86.92.86.45 0 .87-.22.87-.63 0-.41-.58-.59-1.52-.83-1.54-.41-3.58-.95-3.58-3.65 0-2.3 1.55-3.67 4.14-3.67s4.11 1.44 4.11 3.85h-3.36c0-.64-.54-.71-.78-.71-.07 0-.7.01-.7.44 0 .38.7.57 1.51.79 1.55.43 3.66 1.01 3.66 3.72 0 2.41-1.66 3.91-4.34 3.91Z",
    fill: "current"
  })));
};
export default SvgIconJs48Filled;